import { render } from "./TimetableCard.vue?vue&type=template&id=fdce312a&scoped=true&ts=true"
import script from "./TimetableCard.vue?vue&type=script&lang=ts"
export * from "./TimetableCard.vue?vue&type=script&lang=ts"

import "./TimetableCard.vue?vue&type=style&index=0&id=fdce312a&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdce312a"]])

export default __exports__